module.exports = __webpack_public_path__ + "img/icon4_highlight.1e723cfd.png";